
import '../css/dataTablePopUp.css';
import '../css/draggableColumn.css';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    useNodesState,
    useEdgesState,
    Controls,
} from 'reactflow';
import 'reactflow/dist/style.css';





const LineChartPopupComponent = ({ onClose, onRemoveTable, nodeName,
    selectedNodeId, onValueSubmit, selectedCurrentDatabasesCombined, selectedCurrentTablesCombined,
    selectedColumnsCombined, selectedCombinedColumnsValue,
    leftListValue, rightListValue, verticalLabelValue,
    horizantalLabelValue, selectedCurrentTable, selectedPreviousTable }) => {




    console.log(JSON.stringify(selectedColumnsCombined) + "selectedColumnsCombined");
    console.log(JSON.stringify(selectedCombinedColumnsValue) + "selectedCombinedColumnsValue");
    console.log(JSON.stringify(leftListValue) + "leftListValue");
    console.log(JSON.stringify(rightListValue) + "rightListValue");
    console.log(JSON.stringify(selectedPreviousTable) + "selectedPreviousTable");
    console.log(JSON.stringify(selectedCurrentTable) + "selectedCurrentTable");

    const [name, setName] = useState(nodeName);
    const [selectedCombinedColumns, setSelectedCombinedColumns] = useState(
        selectedCombinedColumnsValue && selectedCombinedColumnsValue.length > 0 ? selectedCombinedColumnsValue : '');


    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);

    const [leftList, setLeftList] = useState(
        leftListValue && leftListValue.length > 0 ? leftListValue : selectedColumnsCombined || []);
    // const [leftList, setLeftList] = useState(
    //     selectedColumnsCombined && selectedColumnsCombined.length > 0 ? selectedColumnsCombined : []);


    const [rightList, setRightList] = useState(
        rightListValue && rightListValue.length > 0 ? rightListValue : []
    );
    const [verticalLabel, setVerticalLabel] = useState(
        verticalLabelValue && verticalLabelValue.length > 0 ? verticalLabelValue : '');
    const [horizantalLabel, setHorizantalLabel] = useState(
        horizantalLabelValue && horizantalLabelValue.length > 0 ? horizantalLabelValue : ''
    );

    const handleRemoveTable = () => {
        // Call the onRemoveTable callback function
        if (onRemoveTable) {
            onRemoveTable();
        }
        // Close the popup
        onClose();
    };

    useEffect(() => {
        // Perform actions after leftList and rightList are updated
        console.log('leftList updated:', leftList);
        console.log('rightList updated:', rightList);

        // You can perform any additional logic or actions here
    }, [leftList, rightList]);

    useEffect(() => {
        // setShowAdditionalInputs(showAdditionalinputlength > 0 ? [{}] : []);

        setName(nodeName);
        setSelectedCombinedColumns(selectedCombinedColumns);
        setVerticalLabel(verticalLabel);
        setHorizantalLabel(horizantalLabel);

        if (selectedPreviousTable && selectedCurrentTable
            && selectedCurrentTable !== selectedPreviousTable) {
            setLeftList(selectedColumnsCombined);
            setRightList([]);
        }
        else {

            if (selectedPreviousTable == undefined && selectedCurrentTable) {
                setLeftList(selectedColumnsCombined);
                setRightList([]);
            } else if (selectedCurrentTable !== undefined && selectedPreviousTable !== undefined &&
                selectedCurrentTable === selectedPreviousTable) {

                const combinedLength = leftListValue.length + rightListValue.length;

                if (combinedLength !== selectedColumnsCombined.length) {
                    // The combined length of leftListValue and rightListValue is different from selectedColumnsCombined
                    setLeftList(selectedColumnsCombined);
                    setRightList([]);
                } else {
                    // Check if all items in rightListValue are present in selectedColumnsCombined
                    const isRightListValid = rightListValue.every(item => selectedColumnsCombined.includes(item));

                    if (isRightListValid) {
                        setLeftList(leftListValue);
                        setRightList(rightListValue);
                    } else {
                        setLeftList(selectedColumnsCombined);
                        setRightList([]);
                    }
                    // setLeftList(leftListValue);
                    // setRightList(rightListValue);
                }
            } else {
                setLeftList(selectedColumnsCombined);
                setRightList([]);
            }

        }
    }, [nodeName, selectedCombinedColumns, verticalLabel, horizantalLabel]
    );


    const handleLinkClick = () => {
        // Perform any actions when the link is clicked
        // ...
    };

    const handleColumnChange = (event) => {
        const selectedColumnName = event.target.value;
        setSelectedCombinedColumns(selectedColumnName);
    };

    const handleVerticalChange = (event) => {
        setVerticalLabel(event.target.value);
    };

    const handleHorizantalChange = (event) => {

        setHorizantalLabel(event.target.value);
    };

    const renderColumnOptions = () => {
        if (selectedColumnsCombined) {
            return selectedColumnsCombined.map((column) => (
                <option key={column} value={column}>
                    {column}
                </option>
            ));
        }
        return null;
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        onValueSubmit(selectedNodeId, name, selectedCombinedColumns,
            leftList, rightList, verticalLabel, horizantalLabel, selectedCurrentTable, selectedColumnsCombined
        );
        // Perform the submit action with the formData
        // ...
    };
    // Function to update the dynamic value
    const handleNameChange = (event) => {

        setName(event.target.value);
    };


    const onDragStart = (event, column) => {

        event.dataTransfer.setData('application/reactflow', JSON.stringify(column));
        event.dataTransfer.effectAllowed = 'move';
    };
    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);

    const handleAddAll = () => {
        setRightList((prevRightList) => [...prevRightList, ...leftList]);
        setLeftList([]);
    };
    const handleRemoveAll = () => {
        setLeftList((prevLeftList) => [...prevLeftList, ...rightList]);
        setRightList([]);
    };


    const handleDeleteColumn = (columnId) => {
        setRightList((columns) => columns.filter((column) => column !== columnId));
        setLeftList((columns) => {
            const existingColumn = rightList.find((column) => column === columnId);
            if (!existingColumn) {
                return [...columns];
            }
            return [...columns, existingColumn];
        });
    };


    const onDrop = useCallback(
        (event, list) => {
            event.preventDefault();

            const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
            const typeData = event.dataTransfer.getData('application/reactflow');
            const type = JSON.parse(typeData);

            if (!type) {
                return;
            }

            const position = reactFlowInstance.project({
                x: event.clientX - reactFlowBounds.left,
                y: event.clientY - reactFlowBounds.top,
            });


            if (list === 'left' && !leftList.find((column) => column === type)) {
                setRightList((columns) => columns.filter((column) => column !== type));
                setLeftList((columns) => [...columns, type]);
            }

            if (list === 'right' && !rightList.find((column) => column === type)) {
                setLeftList((columns) => columns.filter((column) => column !== type));
                setRightList((columns) => [...columns, type]);
            }
        },
        [reactFlowInstance, leftList, rightList]
    );



    return (
        <div className="overlay">

            <div className="popup-datatable">
                <div className="popup-header">
                    <h4 class='modal-title'>Tool Options</h4>
                    <button className="close-button" onClick={onClose}>

                        <span>&times;</span>
                    </button>
                </div>
                <div className="datatable-content">
                    <div className="modal-body">
                        <div className="form-group">
                            <label htmlFor="textbox">Name</label>
                            <input type="text" value={name}
                                className="form-control"
                                onChange={handleNameChange}
                                id="textbox" />

                        </div>
                        <div className="form-group">
                            <label htmlFor="textbox">Vertical Axis Title </label>
                            <input type="text" value={verticalLabel}

                                onChange={handleVerticalChange}
                                className="form-control" id="textbox" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="textbox">Horizantal Axis Title </label>
                            <input type="text" value={horizantalLabel}
                                onChange={handleHorizantalChange}
                                className="form-control" id="textbox" />
                        </div>


                        <div className="form-group">
                            <label htmlFor="dropdown">Axis Values</label>
                            <select
                                id="dropdown"
                                className="form-control"

                                value={selectedCombinedColumns}
                                onChange={handleColumnChange}
                            >
                                {renderColumnOptions()}
                            </select>

                        </div>
                        <h3>Plot the following columns :</h3>
                        <p className="helpText">Drag columns into the list on the right and reorder as required. Click the 'x' button to remove selected columns.
                        </p>
                        <div className="list-container">


                            <div className="leftlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'left')}>

                                <ul>

                                    {leftList.map((column) => (
                                        <li
                                            key={column}
                                            className="blockItem ui-draggable"
                                            draggable
                                            onDragStart={(event) => onDragStart(event, column)}
                                        >
                                            {column}
                                        </li>
                                    ))}

                                </ul>
                            </div>

                            <ReactFlowProvider>
                                <div className="" ref={reactFlowWrapper}>
                                    <ReactFlow
                                        onInit={setReactFlowInstance}
                                        onDrop={onDrop}
                                        onDragOver={onDragOver}
                                        fitView
                                    >
                                        <Controls />
                                    </ReactFlow>
                                </div>
                            </ReactFlowProvider>
                            <div className="rightlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'right')} >

                                <ul>
                                    {rightList.map((column) => (
                                        <li key={column} className="blockItem ui-draggable" draggable
                                            onDragStart={(event) => onDragStart(event, column)}
                                        >
                                            {column}

                                            <button className="crossmark-button" onClick={() => handleDeleteColumn(column)}>×</button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                        </div>

                        <div className="add-remove">
                            <button type="button" className="btn btn-add" onClick={handleAddAll}>
                                Add All
                            </button>


                            <button type="button" className="btn btn-removeall" onClick={handleRemoveAll}>
                                Remove All
                            </button>
                        </div>


                        <div className="form-group toolHelpLink">
                            <a href="https://example.com" target="_blank" onClick={handleLinkClick}>
                                How does this tool work?
                            </a>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>REMOVE TOOL</button>
                        <button type='button' className='btn btn-primary ok' onClick={handleSubmit}>OK</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LineChartPopupComponent;
